const getDefaultForm = () => ({
  paymentMethod: {
    formaPago: '',
    account: '',
    dateVencimiento: '',
    useCesionario: false,
    cesionario: '',
    cesionarioAccount: '',
  }
})
const getDefaultState = () => {
  return {
    form: getDefaultForm()
  }
}
  
const state = getDefaultState()
const getters = { form: state => state.form }
const mutations = {}
const actions = {
  resetForm ({ state }) {
    state.form = getDefaultForm()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
